import { SimpleMutationOptions, useBaseMutation } from "../baseMutation";
import { HttpRequest } from "@maven-rest/common/HttpRequest";
import { RetryFolderFileConvertPdfRequest, RetryFolderFileConvertPdfResponse } from "@maven-rest/docs/FolderFile.dto";
import { FolderFileUrl } from "@maven-rest/docs/FolderFile.url";

export function useRetryConvertFolderFilePdfMutation(
  options?: SimpleMutationOptions<RetryFolderFileConvertPdfResponse, RetryFolderFileConvertPdfRequest>
) {
  return useBaseMutation({
    mutationFn: async ({ fileId }: RetryFolderFileConvertPdfRequest) => {
      const resp = await HttpRequest.request<RetryFolderFileConvertPdfResponse>(
        process.env.REACT_APP_DOCS_BE_URL || "",
        ...FolderFileUrl.retryConvertFolderFilePdf(fileId),
        {},
        {}
      );

      return resp.data;
    },
    ...options,
  });
}
